import { Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { getContractRouteOfCurrentURL } from "utils/RoutesUtils";
import { lang } from "../../i18nLang";
import { MeasurementStore, MessageStore } from "../../store";
import DialogModal from "../UI/DialogModals";

interface IProps {
  /** Propriedade que indica se o modal está aberto ou fechado. */
  open: boolean;
  /** Função que será chamada ao fechar o modal */
  onClose: () => void;
}

const MeasurementDelete = ({ open, onClose }: IProps) => {
  const history = useHistory();

  const handleConfirm = () => {
    MessageStore.toggleLoading();
    MeasurementStore.deleteMeasurement()
      .then(() => {
        MessageStore.success(lang("measurements.deleted"));
        history.replace(getContractRouteOfCurrentURL());
      })
      .catch((error) => {
        console.error(error);
        const message =
          error?.message.indexOf("Billed") > -1
            ? lang("measurements.error.deleteBilled")
            : lang("measurements.error.delete");
        MessageStore.error(message);
      })
      .finally(() => {
        MessageStore.toggleLoading();
      });
  };

  return (
    <DialogModal
      title={lang("measurements.deleteMeasurementTitle")}
      open={open}
      onClose={onClose}
      onConfirm={handleConfirm}
      confirmLabel={lang("delete")}
      typeConfirm="error"
    >
      <Typography variant="body1">
        {lang("measurements.deleteMeasurementContent")}
      </Typography>
    </DialogModal>
  );
};

export default MeasurementDelete;
